import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit10-introduction',
  templateUrl: './unit10-introduction.component.html',
  styleUrls: ['./unit10-introduction.component.css']
})
export class Unit10IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
